export default __webpack_public_path__ + "static/media/DoubleToro.be562968.png";